import { render, staticRenderFns } from "./t-orm-buttons.vue?vue&type=template&id=17d75299&scoped=true&lang=pug"
import script from "./t-orm-buttons.vue?vue&type=script&lang=js"
export * from "./t-orm-buttons.vue?vue&type=script&lang=js"
import style0 from "./t-orm-buttons.vue?vue&type=style&index=0&id=17d75299&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d75299",
  null
  
)

export default component.exports